import styled from 'styled-components';
import { black } from 'constants/color';

export * from 'components/Settings/Order';
export * from 'components/Settings/Settings';
export * from 'components/Settings/Accounting';
export * from 'components/Settings/EmailNotification';

export const StyledHeader = styled.h1`
  color: ${black};
`;
